// extracted by mini-css-extract-plugin
export default {"start":"elementNumbers_start__xQeQU","end":"elementNumbers_end__vwZe4"};